import type { ReactNode } from 'react';

export type TabItem<T extends string> = {
  id: T;
  label: ReactNode;
};

export function Tabs<T extends string>({
  items,
  value,
  onChange,
}: {
  items: TabItem<T>[];
  value: T;
  onChange: (id: T) => void;
}) {
  return (
    <div className="ui-tabs" role="tablist">
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          role="tab"
          aria-selected={it.id === value}
          className={`ui-tab ${it.id === value ? 'is-active' : ''}`}
          onClick={() => onChange(it.id)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}

export type ChipItem<T extends string> = {
  id: T;
  label: ReactNode;
};

export function Chips<T extends string>({
  items,
  value,
  onChange,
}: {
  items: ChipItem<T>[];
  value: T;
  onChange: (id: T) => void;
}) {
  return (
    <div className="ui-toolbar">
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          className={`ui-chip ${it.id === value ? 'is-active' : ''}`}
          onClick={() => onChange(it.id)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
